function formatDate(date: string) {
	const value = new Date(date)
	const formatted = new Intl.DateTimeFormat('pr-BR').format(value)

	return formatted
}

export { formatDate }
